<template>
    <div class="nav-header flex-none transition items-center">

          <div v-show="popoutHidden" class="flex w-full">
            <div class="flex-1">
              <button v-on:click="popoutHidden = !popoutHidden"
                class="nav-icon align-middle cursor-pointer relative border-0 bg-transparent hover:bg-transparent w-full focus:bg-gray-900 focus:outline-none rounded-none pr-0"
                aria-label="Help"
                aria-expanded="false"
              >
                <i aria-hidden="true" class="material-icons pr-0">{{icon}}</i>
                <i aria-hidden="true" class="material-icons pr-0 absolute arrow">keyboard_arrow_right</i>
              </button>
            </div>
          </div>

          <div v-if="!popoutHidden" class="visible-popout">
            <div class="flex-1">
              <button v-on:click="popoutHidden = true"
                class="nav-icon align-middle cursor-pointer relative is-active border-0 bg-transparent hover:bg-transparent w-full focus:bg-gray-900 focus:outline-none rounded-none pr-0"
                aria-label="Help"
                aria-expanded="true"
              >
                <i aria-hidden="true" class="material-icons pr-0">{{icon}}</i>
                <i aria-hidden="true" class="material-icons pr-0 absolute arrow">keyboard_arrow_left</i>
              </button>
            </div>
              <div class="full-popout inner-popout" v-click-outside="onClickOutside">
                <slot></slot>
              </div>
          </div>
        
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

  export default {

      props: {
        name: '',
        icon: '',
      },

        data() {
          return {
            popoutHidden: true,
            success: false,
            loaded: true,
          }
        },

        directives: {
          clickOutside: vClickOutside.directive
        },
        methods: {
          onClickOutside (event) {
              this.popoutHidden = !this.popoutHidden
              // console.log('Clicked outside. Event: ', event)
          }
        }

      };
</script>
